(function (Cobalt) {
    var HomePage = /** @class */ (function () {
        function HomePage() {
        }
        HomePage.RegisterAboveContentMobileNav = function () {
            ///<summary>Enables navigation of recent threads from mobile on homepage</summary>
            //fragileness ensues
            $(document).ready(function () {
                var $firstNav = $("div.mobile-view-1");
                var $secondNav = $("div.mobile-view-2");
                var $firstButton = $("div.first-nav a");
                var $secondButton = $("div.second-nav a");
                $firstButton.click(function () {
                    $firstButton.parent().addClass("selected");
                    $secondButton.parent().removeClass("selected");
                    $secondNav.removeClass("selected");
                    $firstNav.addClass("selected");
                });
                $secondButton.click(function () {
                    $secondButton.parent().addClass("selected");
                    $firstButton.parent().removeClass("selected");
                    $secondNav.addClass("selected");
                    $firstNav.removeClass("selected");
                });
            });
        };
        return HomePage;
    }());
    Cobalt.HomePage = HomePage;
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.HomePage.js